import Header from "../header"
import "./index.css"
import TaskBar from "../taskbar";
import CopyRight from "../copyright";

const CountrieAus = () => {

    return (
        <>
        <Header />
        <div className="container-head">
          <h1>Why Choose Australia as Your Study Destination?</h1>  
          <p>Australia is ranked as the 3rd most popular study-abroad destination globally.  </p>
        <p>Key Advantages:  </p>
        <ul>
           <li> Globally Top-Ranked Universities  </li>
           <li>Multicultural, Safe, and Inclusive Communities </li>
           <li>Part-Time Work While Studying (up to 48 hours/fortnight) </li>
           <li>Post-Study Work Rights (up to 6 years)  </li>
           <li>Excellent Healthcare and Public Transport Facilities </li>
           <li>Beautiful Climate, Clean Cities, and Vibrant Culture  </li>
        </ul>

        <hr />
        <table>
            <caption>Australia at a Glance  </caption>
            <thead>
                <tr>
                    <th>Category</th>
                    <th>Details</th>
                </tr>
            </thead>
                <tr>
                    <td>Capital </td>
                    <td>Canberra </td>
                </tr>
                <tr>
                    <td>Major Cities</td>
                    <td>Sydney, Melbourne, Brisbane, Perth, Adelaide </td>
                </tr>
                <tr>
                    <td>Official Language</td>
                    <td>English</td>
                </tr>
                <tr>
                    <td>Currency </td>
                    <td>Australian Dollar (AUD) </td>
                </tr>
                <tr>
                    <td>Major Intake </td>
                    <td>February, July, November </td>
                </tr>
                <tr>
                    <td>Tuition Range</td>
                    <td>AUD 20,000 – 45,000/year  </td>
                </tr>
                <tr>
                    <td>Part-Time Work</td>
                    <td>48 hours per fortnight during study</td>
                </tr>
        </table>
        

        <hr />

        <h2>Australia's Education System</h2>

         <p>Australia’s education system is internationally recognized for its innovation, quality, and student focus. </p>
         
        <p>Key Features</p>
        <ul>
            <li>43 Universities: Including prestigious Group of Eight (Go8) research universities. </li>
            <ul>
            Higher Education Qualifications:
            <li> Bachelor's Degree: 3–4 years</li> 
            <li>Master's Degree: 1–2 years (Coursework / Research)</li>
            <li>Doctoral Degree (Ph.D.): 3–4 years </li>
            </ul>
            <li>Flexible Pathways: Pathway programs available for students who do not meet direct entry requirements. </li>
            <li>Practical Learning: Focus on real-world skills, internships, industry placements, and hands on projects. </li>
            <li>TEQSA Accreditation: All universities are regulated by the Tertiary Education Quality and Standards Agency (TEQSA) ensuring high academic standards. </li>
        </ul>  
        <hr />
        <h2>Popular Programs to Study</h2>
        <table>
            <thead>
                <tr>
                    <th>Study Area </th>
                    <th>Courses</th>
                </tr>
            </thead>
                <tr>
                    <td>Business & Management</td>
                    <td> MBA, Project Management, Finance, Business Analytics</td>
                </tr>
                <tr>
                    <td>Technology & IT </td>
                    <td>Computer Science, Data Science, Cybersecurity, AI </td>
                </tr>
                <tr>
                    <td>Healthcare</td>
                    <td>Nursing, Physiotherapy, Public Health, Allied Health </td>
                </tr>
                <tr>
                    <td>Law & Humanities </td>
                    <td>LLB, LLM, International Relations </td>
                </tr>
                <tr>
                    <td>Engineering & Science </td>
                    <td>Civil, Mechanical, Electrical, Biomedical, Pharmacy </td>
                </tr>
                </table>
                <p>Emerging Areas: Renewable Energy, Robotics, Fintech, Biotechnology</p>
                <hr/>
                <h2>Admission Requirements</h2>
            <table>
            <thead>
                <tr>
                    <th>Program</th>
                    <th>Academic Score </th>
                    <th>IELTS</th>
                    <th>Other Requirements</th>
                </tr>
            </thead>
                <tr>
                    <td>Bachelor’s </td>
                    <td>60%+ in 12th Grade </td>
                    <td>Overall 6.0 (no band 5.5)   </td>
                    <td>SOP, Resume, Passport, Financials t</td>
                </tr>
                <tr>
                    <td>Master’s </td>
                    <td>60%-65% UG Degree </td>
                    <td>Overall 6.0 (no band 5.5)  </td>
                    <td>Work Experience (for MBA/MS), SOP  </td>
                </tr>
                <tr>
                    <td>Pathway Programs</td>
                    <td>50%-60% in 12th Grade  </td>
                    <td>IELTS 5.5–6.0  </td>
                    <td>Foundation or Diploma courses  </td>
                </tr>
                </table>
                <p>Alternate English Tests Accepted: PTE Academic, TOEFL iBT</p>
            <hr />
            <h2>Investment to Study in Australia </h2>
             
            <p>Tuition Fees: </p>
             <ul>
                <li>Bachelor’s Degree: AUD 20,000 – 40,000/year</li>
                <li>Master’s Degree: AUD 22,000 – 50,000/year</li>
                <li>Ph.D.: AUD 28,000 – 50,000/year</li>
             </ul>
            <p>Living Costs (Estimate, 2024 Update)</p>
            <li>Student: AUD 29,710/year </li>
            <li>Spouse: AUD 10,394/year </li>
            <li>Each Child: AUD 4,449/year</li>
            <hr />
            <h2>Top Universities in Australia </h2>
            <ul>
                <li>University of Melbourne</li>
                <li>Australian National University (ANU)</li>
                <li>University of Sydney</li>
                <li>University of Queensland (UQ) </li>
                <li>Monash University </li>
                <li>University of New South Wales (UNSW) </li>
                <li>University of Western Australia (UWA) </li>
            </ul>

           <hr />

           <h2>How Students Learn in Australia </h2>
           <ul>
              <li>Lecture-Based Learning (Theory & Concepts)</li>
              <li>Tutorials (Small-group Discussions)</li>
              <li>Case Studies & Real-World Simulations </li>
              <li>Research Projects (especially at PG and Ph.D. levels)</li>
              <li>Internships & Industry Placements (Built into most programs)</li>
           </ul>
            <p>Focus: Critical Thinking, Practical Knowledge, Global Perspective.</p>
           <hr/>
             <h2>Scholarships for International Students</h2>
              <p>Dream Destination helps you unlock amazing scholarship opportunities</p>
              <ul>
                <li>Merit Scholarships: Based on academic performance. </li>
                <li>Vice Chancellor’s Excellence Awards: Offered by top universities. </li>
                <li>Destination Australia Scholarships: For studying in regional areas.</li>
                <li>Australia Awards Scholarships: Funded by the Australian Government.</li>
              </ul>
              <p>Scholarships can cover 15% – 100% of tuition fees based on merit.</p>
             <hr />
           <h2>Essential Documents for Visa Application </h2>
           <p>For University Admission: </p>
           <ul>
            <li>AValid Passport  </li>
            <li>Academic Transcripts </li>
            <li>IELTS/PTE Scorecard  </li>
            <li>eCOE (Confirmation of Enrolment)  </li>
            <li>Genuine Temporary Entrant (GTE) Statement  </li>
            <li>Medical Examination </li>
            <li>Health Insurance (OSHC) </li>
           </ul>
            <hr/>
            <h2>Post-Study Work Rights  </h2>
             <table>
                <thead>
                    <tr>
                        <th>Qualification</th>
                        <th>Post-Study Work Duration </th>
                    </tr>
                </thead>
                <tr>
                    <td>Bachelor's</td>
                    <td>2–4 years</td>
                </tr>
                <tr>
                    <td>Master's (Coursework/Research)</td>
                    <td>3–5 years</td>
                </tr>
                <tr>
                    <td>Doctorate (Ph.D.)</td>
                    <td>Up to 6 years</td>
                </tr>
             </table>
             <p>Additional 1–2 years for regional study locations.</p>
             <hr />
             <h2>Life in Australia as an International Student</h2>
             <ul>
                <li>Safe, multicultural society</li>
                <li>Stunning beaches, parks, and natural wonders</li>
                <li>Easy public transport in major cities </li>
                <li>World-famous festivals, events, and cultural experiences </li>
                <li>Student discounts on travel, entertainment, and living </li>
             </ul>
        </div>
        <TaskBar />
        <CopyRight />
        </>
    )

}

export default CountrieAus